import {AxiosInstance} from 'axios'
import MyAxiosInstancePriceResearch from './axiosInstancePriceResearch'
import {
    ConsultaDetail,
    ConsultaList,
    ConsultaOut,
    FornecedorBuscaOut,
} from '../types/radarFornecedor'

export class RadarFornecedorApiService {
    private api: AxiosInstance

    constructor() {
        this.api = MyAxiosInstancePriceResearch
    }

    async criarConsulta(
        cnpj: string,
        periodo_meses = 24,
        nome?: string
    ): Promise<ConsultaOut> {
        const {data} = await this.api.post('/fornecedores', {
            cnpj,
            periodo_meses,
            nome: nome || undefined,
        })
        return data
    }

    async buscarPorNome(nome: string): Promise<FornecedorBuscaOut> {
        const {data} = await this.api.get('/fornecedores/buscar', {
            params: {nome},
        })
        return data
    }

    async getConsulta(id: string): Promise<ConsultaDetail> {
        const {data} = await this.api.get(`/fornecedores/${id}`)
        return data
    }

    async listarConsultas(limit = 20, offset = 0): Promise<ConsultaList> {
        const {data} = await this.api.get('/fornecedores', {
            params: {limit, offset},
        })
        return data
    }

    async removerConsulta(id: string): Promise<void> {
        await this.api.delete(`/fornecedores/${id}`)
    }

    async exportarPdf(id: string): Promise<Blob> {
        const {data} = await this.api.get(`/fornecedores/${id}/pdf`, {
            responseType: 'blob',
        })
        return data
    }
}
